var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Arrow_Left_2_Line",
    "data-name": "icons/Arrow Left 2/Line",
    transform: "translate(13 15.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector_Stroke_",
    "data-name": "vector (Stroke)",
    d: "M10.5-.322l3.231-3.5a1,1,0,0,0,0-1.357L10.5-8.678a1,1,0,0,0-1.413-.057,1,1,0,0,0-.057,1.413L10.716-5.5H1a1,1,0,0,0-1,1,1,1,0,0,0,1,1h9.716L9.034-1.678A1,1,0,0,0,9.091-.265,1,1,0,0,0,10.5-.322Z",
    transform: "translate(14 0) rotate(180)",
    fill: "#777e90"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    fill: "none",
    stroke: "#e6e8ec",
    strokeWidth: 2,
    strokeDasharray: "0 0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.b3627e0b1ddc6d91e548931f77c88bd3.svg";
export { ForwardRef as ReactComponent };